import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import VueMeta from 'vue-meta'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['trackPageview', to.fullPath])
    }
  }
  next()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
